<template>
  <!-- Popup mère -->
  <div v-if="visible" class="popup-overlay z-1" @click="close" @wheel.stop>
    <div class="flex flex-col w-fit rounded-xl overflow-auto !h-fit" @click.stop>
      <!-- Header du popup -->
      <div class="flex justify-between items-center p-4 pb-2 bg-white h-fit">
        <div class="text-xl font-bold ml-1 select-none">{{ title }}</div>
        <button class="!p-0 !m-0 rounded-full !bg-white flex items-center justify-center m-0 cursor-pointer" @click="close">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>

      <!-- Contenu du popup -->
      <div class="rounded-b-lg bg-white w-fit h-fit p-4 relative">
        <form class="flex flex-col gap-8" @submit.prevent="formSubmit">
          <div
            v-if="blockOverlay"
            style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;cursor:not-allowed;background:rgba(255,255,255,0.01);"
            @mousedown.stop
            @mouseup.stop
            @click.stop
            @pointerdown.stop
            @pointerup.stop
            @touchstart.stop
            @touchend.stop
          ></div>

          <slot></slot>

          <!-- Footer du popup -->
          <div class="flex justify-end w-full bg-white h-9 gap-3" v-if="!noButtons">
              <template v-if="add && !update">
                <button class="basicDiv bg-transparent m-0 !h-full flex items-center px-3 border-none !px-4 !py-2 !rounded-xl select-none" @click="$emit('close')" type="button">Annuler</button>
                <button class="callToAction !rounded-xl m-0 !h-full !px-4 !py-2 select-none" type="submit" 
                        :disabled="addDisabled">
                    Ajouter
                </button>
              </template>
              <template v-else>
                <button v-if="!update" class="basicDiv bg-transparent m-0 !h-full flex items-center px-3 border-none !px-4 !py-2 !rounded-xl select-none" @click="$emit('close'); $emit('delete')" type="button">Supprimer</button>
                <button class="callToAction !rounded-xl m-0 !h-full  !px-4 !py-2 select-none" :class="update ? 'z-1001' : ''" type="submit">
                    Enregistrer
                </button>
              </template>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import closeIcon from '@/assets/close.png';

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    add: {
      type: Boolean,
      default: true
    },
    update: {
      type: Boolean,
      default: false
    },
    addDisabled: {
      type: Boolean,
      default: false
    },
    noButtons: {
      type: Boolean,
      default: false
    },
    blockOverlay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formSubmit(){
      if(this.add){
        this.$emit('add');
      } else {
        this.$emit('update');
      }
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    }
  },
  data() {
    return {
      closeIcon
    };
  }
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
</style>